import paging from './../../components/_paging';
import commonMixin from '../../mixins/_common';
import modalMixin from './../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';

/**
 * ブランドコードのリストコンポーネント
 */
const brandList = {
    name: 'brandList',
    template: '#brand_list_template',
    props: {
        // ブランドコード情報
        brands: {
            type: Array,
            default: [],
        },
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin
    ],
    emits: ['emit-select-brand'],
};

/**
 * ブランド設定コンポーネント
 */
export default {
    name: 'brandSelector',
    template: '#brand_selector_component_template',
    data () {
        return {
            // ブランドリスト
            brands: [],
            // 検索キーワード
            keyword: '',
            // 選択中のブランド名
            selected_brand: '',
            // 総ページ数
            pages: 0,
            // 現在のページ番号
            current_page: 1,
        };
    },
    props: {
        // プロダクトカテゴリパス名
        product_path_name: {
            type: String,
            default: null
        },
        // v-modelの値(選択中のブランドコード)
        modelValue: {
            type: [String, Number],
            default: null
        }
    },
    components: {
        'brand-list': brandList,
        'paging': paging,
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin
    ],
    async mounted () {
        await this.getBrands();

        this.setSelectedBrandName();
    },
    watch: {
        modelValue: {
            async handler() {
                this.setSelectedBrandName();
            },
        }
    },
    computed: {
        // 選択中のプロダクトカテゴリ名(第1階層)
        product_name: function () {
            return this.product_path_name ?
                this.product_path_name.substr(0, this.product_path_name.indexOf(' ')) :
                '';
        },
        // ブランド一覧が取得されているか
        hasBrands: function () {
            return (this.brands.length > 0);
        },
    },
    emits: ['update:modelValue'],
    methods: {
        // ブランド一覧取得処理
        getBrands: async function (page = 1) {
            // 初期化
            this.brands = [];

            let message = this.exception_error_message;

            try {
                this.$_loading();

                const response = await axios.get('/brand/get_product_brand', {
                    params: {
                        brand_id: this.modelValue,
                        product_name: this.product_name,
                        keyword: this.keyword,
                        page: page,
                    }
                });
                if (response.data.status == 'OK') {
                    // ブランドデータをセット
                    this.brands = response.data.brands.data;
                    // ページ数
                    this.pages = response.data.brands.last_page;
                    // 現在のページ
                    this.current_page = page;

                    message = '';
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                });
            }

            this.$_unloading();

            return false;
        },
        // 選択中のブランド名をセット
        setSelectedBrandName: function () {
            this.selected_brand = '';
            this.brands.forEach(brand => {
                if (this.modelValue == brand.brand_id) {
                    this.selected_brand = brand.name;
                    return false;
                }
            }, this);
        },
        // モーダルオープン
        show: async function () {
            // ヤフーyahooAPI用アクセストークンが有効かチェック(トークンがリフレッシュされる)
            if (!await this.$root.$refs.yahooAuth.isValidToken()) {
                return;
            }

            this.keyword = '';
            this.getBrands();

            this.open();
        },
        // ブランド選択
        selectBrand: function (brand_code) {
            this.setSelectedBrandName();

            this.$emit('update:modelValue', brand_code);

            this.close();
        }
    }
};